module.exports = __webpack_public_path__ + "assets/img/triangle.6c943608.svg";